// This file was automatically generated and should not be edited.
/* eslint-disable */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_seo_meditations_guided_meditations: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `<strong>Guided Meditations</strong><br>Yoga International’s guided meditations will help you connect to the present moment and guide you toward greater self-awareness, self-acceptance, and self-compassion.`,
    es: `<strong>Meditaciones Guiadas</strong><br>Las meditaciones guiadas de Yoga International te ayudarán a conectarte con el momento presente y te guiarán hacia una mayor autoconciencia, autoaceptación y autocompasión.`,
  };
  return phrases[locale] || phrases.en || 'seo_meditations_guided_meditations';
};
